import React from 'react';

import {
  KSEFRoleEnum,
  KSEFRoleEnumText,
} from '../../../common/spdCore/validation/enums';
import { Option, Selector } from '../Selects/Selector';

const allOptions: Option[] = Object.values(KSEFRoleEnum).map(value => ({
  value,
  label: KSEFRoleEnumText[value],
}));

interface KsefRoleSelectorProps {
  value?: string | null;
  onChange: (value: KSEFRoleEnum | null) => void;
  readOnly?: boolean;
}

export const KsefRoleSelector: React.FC<KsefRoleSelectorProps> = ({
  value,
  onChange,
  readOnly,
}) => {
  const displayLabel = value
    ? (KSEFRoleEnumText[value as KSEFRoleEnum] ?? '')
    : '';

  const provider = async (text: string): Promise<Option[]> => {
    if (!text) {
      return allOptions;
    }
    return allOptions.filter(o =>
      o.label.toLowerCase().includes(text.toLowerCase()),
    );
  };

  const handleChange = (option: Option) => {
    onChange(option?.value ? (option.value as KSEFRoleEnum) : null);
  };

  return (
    <Selector
      uniqueKey={'ksef-role-' + (value ?? 'empty')}
      value={displayLabel}
      provider={provider}
      onChange={handleChange}
      clearable
      readOnly={readOnly}
      placeholder="Wybierz rolę..."
    />
  );
};
